import React from 'react'

interface ArrowBigRightProps {
  size?: number
  color?: string
}

export const ArrowBigRight: React.FC<ArrowBigRightProps> = ({
  size = 24,
  color = '#000',
}) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 12h18m-6-6l6 6-6 6"
        stroke={color}
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
